"use client";

import React, { Suspense, lazy } from "react";
import { Card, Box, Typography, Grid } from "@mui/material";

const Chart = lazy(() => import("react-apexcharts"));

const SpokeRevenueChart = ({ data = [], metrics = {} }) => {
    const categories = data.map((d) => d.month);
    const seriesData = data.map((d) => d.revenue);

    const series = [{ name: "Revenue", data: seriesData }];

    const options = {
        chart: { toolbar: { show: false }, zoom: { enabled: false } },
        colors: ["#605DFF"],
        stroke: { curve: "smooth", width: 2 },
        dataLabels: { enabled: false },
        xaxis: {
            categories,
            axisBorder: { show: false },
            axisTicks: { show: false },
            labels: { style: { colors: "#64748B", fontSize: "12px" } },
        },
        grid: { show: true, borderColor: "#ECEEF2", strokeDashArray: 0 },
        yaxis: {
            labels: { style: { colors: "#64748B", fontSize: "12px" } },
        },
    };

    return (
        <Card
            sx={{
                boxShadow: "none",
                borderRadius: "7px",
                p: { xs: 2, sm: 3 },
                height: "100%",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Box mb={2}>
                <Typography variant="h6" fontWeight={700} gutterBottom>
                    Revenue for Spokes
                </Typography>
                <Grid container spacing={2}>
                    <Grid size="grow">
                        <Box>
                            <Typography variant="caption" color="text.secondary">
                                No. of Stores
                            </Typography>
                            <Typography variant="h6" fontWeight={600}>
                                {metrics.total_stores}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid size="grow">
                        <Box>
                            <Typography variant="caption" color="text.secondary">
                                No. of Clients
                            </Typography>
                            <Typography variant="h6" fontWeight={600}>
                                {metrics.total_clients}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid size="grow">
                        <Box>
                            <Typography variant="caption" color="text.secondary">
                                This month
                            </Typography>
                            <Typography variant="h6" fontWeight={600} color="success.main">
                                ${metrics.earned_pm?.toLocaleString()}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            <Box sx={{ flexGrow: 1, minHeight: 300 }}>
                <Suspense fallback={<div>Loading Chart...</div>}>
                    <Chart options={options} series={series} type="area" height="100%" />
                </Suspense>
            </Box>
        </Card>
    );
};

export default SpokeRevenueChart;
